import { Controller } from "@hotwired/stimulus";

/*
 * <div
 *   data-classes-toggler-target="item"
 *   data-classes-toggler-id="itemId"
 *   data-classes-toggler-on-class="clases cuando está encendido"
 *   data-classes-toggler-off-class="clases cuando está apagado"
 *   ></div>
 *
 * <button
 *   data-action="classes-toggler#toggle"
 *   data-classes-toggler-id-param="itemId"></button>
 */
export default class extends Controller {
  static targets = ["item"];

  toggle({ params: { id } }) {
    for (const itemTarget of this.itemTargets) {
      const {
        classesTogglerId,
        classesTogglerOnClass,
        classesTogglerOffClass,
      } = itemTarget.dataset;
      const onClasses = (classesTogglerOnClass || "").split(" ");
      const offClasses = (classesTogglerOffClass || "").split(" ");

      if (classesTogglerId === id) {
        itemTarget.classList.add(...onClasses);
        itemTarget.classList.remove(...offClasses);
      } else {
        itemTarget.classList.remove(...onClasses);
        itemTarget.classList.add(...offClasses);
      }
    }
  }
}
